import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { css } from "styled-components";
export const trackStyles = css `
  background-color: ${color.background.default};
  border-radius: ${size.borderRadius};

  &.dark {
    background-color: ${color.background.darker};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2tTdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TY3JvbGxiYXIvc3R5bGVkL3RyYWNrU3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDN0UsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBRXhDLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxHQUFHLENBQUE7c0JBQ1IsS0FBSyxDQUFDLFVBQVUsQ0FBQyxPQUFPO21CQUMzQixJQUFJLENBQUMsWUFBWTs7O3dCQUdaLEtBQUssQ0FBQyxVQUFVLENBQUMsTUFBTTs7Q0FFOUMsQ0FBQyJ9